<template>
    <div>
        <p style="font-weight:bold">Enter the verification code from this phone {{SelectedDataChild.countryCode}} {{SelectedDataChild.phone}}.</p>
        <div class="formBlock formBlockDouble">
            <div class="formRow container">
                <div class="col col-2">
                    <input type="text" placeholder="Verification code" class="formText"
                    v-model="SelectedDataChild.verificationCode"
                    @input="$emit('updateSampleData', SelectedDataChild)"
                     />
                </div>
                <div class="col col-2">
                    <input type="submit" value="Verify" class="button button-blue" 
                        @click="$emit('moveToStep', [3,4])"
                     />
                </div>
            </div>
        </div>
        <p style="font-weight:bold">Or, change authentication method, 
            <a href="javascript:void(0)" 
            @click="verificationChange()">{{SelectedDataChild.verification1}} me a code</a>.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        SelectedData: Object,
    },
    data: function() {
        return {
            SelectedDataChild: this.SelectedData,
        }
    },
    mounted: function() {
        this.$nextTick(function() {
            this.$emit('loaded', true);
        });
    },
    methods: {
        verificationChange() {
            if(this.SelectedDataChild.verification == 'text') {
                this.SelectedDataChild.verification = 'call';
                this.SelectedDataChild.verification1 = 'text';
                this.buttonName = 'Text Me';
                this.linkText = 'call you, instead';
            } else {
                this.SelectedDataChild.verification = 'text';
                this.SelectedDataChild.verification1 = 'call';
                this.buttonName = 'Call Me';
                this.linkText = 'text you, instead';
            }
            this.$emit('updateSampleData', this.SelectedDataChild);
            this.$emit('moveToStep', [0,2]);
            console.log('done');
        },
    },
}
</script>